import { Navigate, useLocation } from "react-router-dom";
import { useAuthInfo } from "@propelauth/react";
import { hasRequiredRoles } from "@/utils/authUtils";

type ProtectedRouteProps = {
  children: React.ReactNode;
  requiredRoles: string[];
  fallbackPath?: string;
};

export const ProtectedRoute = ({
  children,
  requiredRoles,
  fallbackPath = "/case/all",
}: ProtectedRouteProps) => {
  const authInfo = useAuthInfo();
  const location = useLocation();

  if (!authInfo.isLoggedIn) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (!hasRequiredRoles(authInfo, requiredRoles)) {
    return <Navigate to={fallbackPath} replace />;
  }

  return <>{children}</>;
};
